export default __webpack_public_path__ + "static/media/9.7c979403.png";